import React from "react";
import { PrimaryText, SecondaryText } from "../../styles/global";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";

const DetailsData = [
  {
    title: "Name",
    value: "Pruthvi Patel",
  },
  {
    title: "Email",
    value: "patelpruthvi.01221@gmail.com",
  },
  {
    title: "Education",
    value: "Master's in Data Science (Pursuing)",
  },
  {
    title: "Contact",
    value: "(+1) 437-335-6881",
  },
];

const Details = () => {
  return (
    <>
      <div className="grid grid-cols-1  md:grid-cols-2 items-center gap-8">
        {DetailsData.map((item) => {
          return (
            <div className="flex flex-col items-center">
              <PrimaryText bg={"#ff5757"} className=" ">
                {item.title} :
              </PrimaryText>
              <SecondaryText className="text-center">
                {item.value}
              </SecondaryText>
            </div>
          );
        })}
      </div>
      <div className="flex justify-center items-center w-full mt-14">
        <a href="/resume/Pruthvi_Patel_Resume.pdf" download>
          <button className="primary-btn text-white hover:text[#1d2549]  rounded-md ">
            <DownloadForOfflineIcon className=" mr-2" /> Download Resume
          </button>
        </a>
      </div>
    </>
  );
};

export default Details;
